/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteSurveyResponseRequest } from '../../models/delete-survey-response-request';

export interface DeleteSurveyResponsesAsync$Json$Params {
  
    /**
     * delete request object
     */
    body: DeleteSurveyResponseRequest
}

export function deleteSurveyResponsesAsync$Json(http: HttpClient, rootUrl: string, params: DeleteSurveyResponsesAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, deleteSurveyResponsesAsync$Json.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

deleteSurveyResponsesAsync$Json.PATH = '/api/SurveyResponse';
